import { EmailOutlined, LockOutlined, TextFields, Visibility, VisibilityOff } from "@mui/icons-material";
import { FormControl, FormControlTypeMap, IconButton, SxProps, Theme, useTheme } from "@mui/material";
import React, { ReactNode, forwardRef, useCallback, useMemo, useState } from "react";
import StyledHelperText from "./StyledHelperText";
import StyledInputElement from "./StyledInputElement";
import StyledInputLabel from "./StyledInputLabel";
import StyledInputRoot from "./StyledInputRoot";

interface ITextInput extends React.InputHTMLAttributes<HTMLInputElement> {
  inputContainerProps?: React.HTMLAttributes<HTMLDivElement>;
  inputLabelProps?: React.InputHTMLAttributes<HTMLLabelElement>;
  formControlProps?: FormControlTypeMap;
  label?: string;
  helperText?: string;
  fullWidth?: boolean;
  error?: boolean;
  sx?: SxProps<Theme> | undefined;
  startAdornment?: ReactNode;
  endAdornment?: ReactNode;
}

const TextInput = forwardRef<any, ITextInput>(
  (
    {
      inputContainerProps,
      label,
      inputLabelProps,
      helperText = " ",
      formControlProps,
      fullWidth,
      error,
      sx,
      startAdornment,
      endAdornment,
      ...inputProps
    },
    ref
  ) => {
    const theme = useTheme();
    const palette = useMemo(() => theme.palette as any, [theme]);
    const [hidden, setHidden] = useState(true);
    const toggleHidden = useCallback(() => setHidden((prevState) => !prevState), []);
    return (
      <FormControl fullWidth={fullWidth}>
        {label && <StyledInputLabel {...inputLabelProps}>{label}</StyledInputLabel>}
        <StyledInputRoot sx={sx} {...inputContainerProps}>
          {startAdornment ? (
            startAdornment
          ) : inputProps.type === "email" ? (
            <EmailOutlined htmlColor={palette.text.secondary} />
          ) : inputProps.type === "password" ? (
            <LockOutlined htmlColor={palette.text.secondary} />
          ) : (
            <TextFields htmlColor={palette.text.secondary} />
          )}
          <StyledInputElement
            {...inputProps}
            type={inputProps.type === "password" ? (hidden ? "password" : "text") : inputProps.type}
            ref={ref}
          />
          {inputProps.type === "password" ? (
            <IconButton onClick={toggleHidden}>
              {hidden ? <VisibilityOff color="secondary" /> : <Visibility color="secondary" />}
            </IconButton>
          ) : null}
          {endAdornment ? endAdornment : null}
        </StyledInputRoot>
        {helperText?.trim() && <StyledHelperText error={error}>{helperText}</StyledHelperText>}
      </FormControl>
    );
  }
);

export default TextInput;
